import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*! Provides core utilities for the working with both versions of the ESRI JSAPI.
 *
 * @ai360/core v27.3.0 (https://bitbucket.org/agvanceskyteam/ai360.client.core.git)
 * SSI DO NOT COPY!!!
 */
import { b as e, _ as r } from "./tslib.es6.js";
import { T as t } from "./index.js";
import { d as o, a } from "./enums.js";
import { b as s } from "./geometry/utils.js";
import "./geometry/creator.js";
import "./symbols.js";
import "@arcgis/core/symbols/support/jsonUtils";
import "@arcgis/core/renderers/support/jsonUtils";
import { L as i } from "./utils/map.js";
import "@arcgis/core/Graphic";
import "@arcgis/core/geometry/Geometry";
import "./zone-classification.js";
import "@arcgis/core/geometry/Polygon";
import "@arcgis/core/geometry/geometryEngine";
import "./api/rec.js";
import "uuid";
import "@arcgis/core/geometry/SpatialReference";
import "@arcgis/core/tasks/Locator";
import "@arcgis/core/geometry/support/webMercatorUtils";
import "@arcgis/core/geometry/support/jsonUtils";
import "@arcgis/core/geometry/projection";
import "@terraformer/arcgis";
import "lodash";
import "@arcgis/core/Basemap";
var c, n, p, l;

var BaseToolbar = /*#__PURE__*/function () {
  function BaseToolbar(r, t) {
    _classCallCheck(this, BaseToolbar);

    c.add(this), n.set(this, void 0), p.set(this, void 0), this.map = r.map, this.mapView = r, this.options = t, e(this, p, !1, "f");
  }

  _createClass(BaseToolbar, [{
    key: "initActivation",
    value: function initActivation() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$tool = _ref.tool,
          r = _ref$tool === void 0 ? null : _ref$tool,
          _ref$activate = _ref.activate,
          t = _ref$activate === void 0 ? !0 : _ref$activate,
          _ref$byPassShare = _ref.byPassShare,
          o = _ref$byPassShare === void 0 ? !1 : _ref$byPassShare,
          _ref$forceUpdate = _ref.forceUpdate,
          a = _ref$forceUpdate === void 0 ? !0 : _ref$forceUpdate;

      var s = arguments.length > 1 ? arguments[1] : undefined;
      e(this, n, r, "f"), t && s && s.call(this, r, o, a), this.options.onSetActiveMapTool(r);
    }
  }, {
    key: "activeTool",
    get: function get() {
      return r(this, n, "f");
    }
  }, {
    key: "calculateArea",
    value: function calculateArea(e) {
      return s.calculateArea(e, t.drawTools.areaUnits.esriUnit);
    }
  }, {
    key: "calculateAbsRawArea",
    value: function calculateAbsRawArea(e) {
      return s.calculateAbsRawArea(e, t.drawTools.areaUnits.esriUnit);
    }
  }, {
    key: "forceUpdate",
    value: function forceUpdate() {
      this.options.forceUpdate && !r(this, p, "f") && this.options.forceUpdate();
    }
  }, {
    key: "getAcreageText",
    value: function getAcreageText(e) {
      return "".concat(this.calculateArea(e), " ").concat(t.drawTools.areaUnits.label);
    }
  }, {
    key: "getToolbar",
    value: function getToolbar() {
      return null;
    }
  }, {
    key: "handleError",
    value: function handleError(e) {
      var t = r(this, c, "m", l).call(this, e.message);

      try {
        var _this$options = this.options,
            _r = _this$options.formatMessage,
            _o = _this$options.onDisplayMessage,
            _a = "object" == typeof t ? _r(t) : t;

        "AbortError" === e.name ? console.warn(_a) : _o(_a, e.name);
      } catch (o) {
        console.error("error handling error", e, o);
      }
    }
  }, {
    key: "moveLayerToTop",
    value: function moveLayerToTop(e) {
      if ("allLayers" in this.map) {
        var _r2 = e,
            _t = this.map.allLayers.filter(function (e) {
          return "graphics" === e.type;
        });

        this.map.reorder(_r2, _t.length + this.map.allLayers.length);
      }
    }
  }, {
    key: "moveLayersToTop",
    value: function moveLayersToTop(e) {
      var _this = this;

      e.forEach(function (e) {
        return _this.moveLayerToTop(e);
      });
    }
  }, {
    key: "redo",
    value: function redo(e, r) {
      var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : e.canRedo();
      t && e.redo().then(r);
    }
  }, {
    key: "setActiveTool",
    value: function setActiveTool(r) {
      e(this, n, r, "f");
    }
  }, {
    key: "setGettingToolbar",
    value: function setGettingToolbar(r) {
      e(this, p, r, "f");
    }
  }, {
    key: "pushToasterMessage",
    value: function pushToasterMessage(e) {
      var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : o.WARNING;
      var t = arguments.length > 2 ? arguments[2] : undefined;
      var a = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
      var _this$options2 = this.options,
          s = _this$options2.formatMessage,
          i = _this$options2.onPushToasterMessage;
      i && i("object" == typeof e ? s(e) : e, r, t, a);
    }
  }, {
    key: "undo",
    value: function undo(e, r) {
      var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : e.canUndo();
      t && e.undo().then(r);
    }
  }, {
    key: "getLayer",
    value: function getLayer(e) {
      var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : a.GraphicsLayer;
      var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var o = this.map.findLayerById(e);
      return o || (r === a.FeatureLayer && ("source" in t || "url" in t || (t.source = []), "objectIdField" in t || "url" in t || (t.objectIdField = "OBJECTID"), "spatialReference" in t || "url" in t || (t.spatialReference = this.mapView.spatialReference), "geometryType" in t || "url" in t || (t.geometryType = "polygon")), o = i.create(r, _objectSpread(_objectSpread({}, t), {}, {
        id: e
      })), o.title = e), this.map.add(o), o;
    }
  }, {
    key: "setLayers",
    value: function setLayers(_ref2) {
      var e = _ref2.fieldsLayer,
          r = _ref2.fieldBoundaryImportLayer;
      this.fieldsLayer = e, this.fieldBoundaryImportLayer = r;
    }
  }, {
    key: "setSharedMapTool",
    value: function setSharedMapTool() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.activeTool !== e && this.initActivation({
        tool: e,
        activate: !0,
        byPassShare: !0
      });
    }
  }]);

  return BaseToolbar;
}();

n = new WeakMap(), p = new WeakMap(), c = new WeakSet(), l = function l(e) {
  try {
    return JSON.parse(e);
  } catch (r) {
    return e;
  }
};
export { BaseToolbar as B };